var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"plain-unordered-list"},_vm._l((_vm.documents),function(doc,index){return _c('li',{key:index},[_c('a',{attrs:{"href":_vm.getUrl(doc),"target":"_blank"}},[_vm._v(" "+_vm._s(doc.name)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }